"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOfferUnderContractSubjectSpecialConditionDto = instanceOfOfferUnderContractSubjectSpecialConditionDto;
exports.OfferUnderContractSubjectSpecialConditionDtoFromJSON = OfferUnderContractSubjectSpecialConditionDtoFromJSON;
exports.OfferUnderContractSubjectSpecialConditionDtoFromJSONTyped = OfferUnderContractSubjectSpecialConditionDtoFromJSONTyped;
exports.OfferUnderContractSubjectSpecialConditionDtoToJSON = OfferUnderContractSubjectSpecialConditionDtoToJSON;
exports.OfferUnderContractSubjectSpecialConditionDtoToJSONTyped = OfferUnderContractSubjectSpecialConditionDtoToJSONTyped;
/**
 * Check if a given object implements the OfferUnderContractSubjectSpecialConditionDto interface.
 */
function instanceOfOfferUnderContractSubjectSpecialConditionDto(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('condition' in value) || value['condition'] === undefined)
        return false;
    return true;
}
function OfferUnderContractSubjectSpecialConditionDtoFromJSON(json) {
    return OfferUnderContractSubjectSpecialConditionDtoFromJSONTyped(json, false);
}
function OfferUnderContractSubjectSpecialConditionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'condition': json['condition'],
    };
}
function OfferUnderContractSubjectSpecialConditionDtoToJSON(json) {
    return OfferUnderContractSubjectSpecialConditionDtoToJSONTyped(json, false);
}
function OfferUnderContractSubjectSpecialConditionDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'condition': value['condition'],
    };
}
